
  import Vue, {PropType} from "vue";
  import PwaPrice from "@/components/common/PwaPrice.vue";

  export default Vue.extend({
    name: "pwa-accept-competition-proposal-modal",
    components: {
      PwaPrice,
    },
    props: {
      competitionProposal: {
        type: Object,
        required: false,
      },
      acceptCompetitionProposal: {
        type: Function as PropType<(competitionProposal: Record<string, any>, competitionFreeInscriptionId: number) => void>,
        required: false,
        default: null,
      },
      acceptCompetitionProposalHidden: {
        type: Function as PropType<() => void>,
        required: false,
        default: () => {
          //Nothing to do
        },
      }
    },
    computed: {
      title(): string {
        const username = this.competitionProposal ? this.competitionProposal.owner.username : '-';

        return this.competitionProposal && this.competitionProposal.rematch_competition_id
          ? this.$t('485', {username})
          : this.$t('484', {username});
      },
    },
    methods: {
      closeModal() {
        (this.$refs.modal as any).hide();
      },
      onAcceptCompetitionProposalClick(competitionFreeInscriptionId = 0) {
        if (this.acceptCompetitionProposal) {
          this.acceptCompetitionProposal(this.competitionProposal, competitionFreeInscriptionId);
        }

        this.closeModal();
      }
    },
  });
